import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  signal,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OdlInputEvent } from '@odilo/ui-components';
import { QuestionsNavigationGuardService } from '../../services/questions-navigation-guard/questions-navigation-guard';

/**
 * Tells a student the current page has unanswered questions: either why a forward jump was refused,
 * or asking them to confirm they want to move on anyway.
 */
@Component({
  selector: 'nr-unanswered-questions-dialog',
  imports: [TranslatePipe],
  templateUrl: './unanswered-questions-dialog.html',
  styleUrl: './unanswered-questions-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UnansweredQuestionsDialogComponent {
  private readonly guard = inject(QuestionsNavigationGuardService);

  readonly isWarningOpen = this.guard.showWarning;

  readonly isConfirmationOpen = this.guard.showConfirmation;

  readonly dontAskAgain = signal(false);

  closeWarning(): void {
    this.guard.dismissWarning();
  }

  toggleDontAskAgain(event: OdlInputEvent<boolean>): void {
    this.dontAskAgain.set(event.detail.value);
  }

  confirm(): void {
    this.guard.confirmNavigation(this.dontAskAgain());
    this.dontAskAgain.set(false);
  }

  cancel(): void {
    if (!this.isConfirmationOpen()) return;
    this.guard.cancelNavigation();
    this.dontAskAgain.set(false);
  }
}
